// Registered style module for the prompt-input-box component.
// Covers composer card, textarea, action buttons, and state variants (idle/welcome/post-reply/busy).

const styleElement = document.createElement("dom-module");

styleElement.innerHTML = /*html*/`<template>
    <style>
    /* ai-composer column (card + controls) */
    .ai-question-input {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding: 0;
      width: 666px;
      max-width: none;
      margin: 0;
    }

    .ai-question-input__header {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;
      width: 100%;
      padding: 12px 12px 12px 24px;
      background: #ffffff;
      border-radius: 18px;
      overflow: hidden;
      min-height: 128px;
    }

    /* Idle composer: one row (textarea + buttons), same as before attachments */
    .ai-question-input__header--idle {
      flex-direction: row;
      align-items: stretch;
      flex-wrap: nowrap;
      gap: 0;
      padding: 12px 12px 12px 24px;
    }

    /* Wrapper ignored for layout until file previews stack below the question row */
    .ai-question-input__header--idle .ai-question-input__composer-row {
      display: contents;
    }

    .ai-question-input__header--idle--with-attachments {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }

    .ai-question-input__header--idle--with-attachments .ai-question-input__composer-row {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      flex-wrap: nowrap;
      gap: 0;
      width: 100%;
      min-width: 0;
    }

    .ai-question-input__attachments {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      width: 100%;
      min-width: 0;
      height: auto;
      align-self: stretch;
    }

    .ai-question-input__attachment-preview {
      position: relative;
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      box-sizing: border-box;
      border-radius: 9px;
      opacity: 1;
      overflow: visible;
      padding: 0;
      border: 0;
    }

    .ai-question-input__attachment-preview[uploading] {
      pointer-events: none;
    }

    .ai-question-input__attachment-loading {
      position: absolute;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
    }

    .ai-question-input__attachment-preview--image .ai-question-input__attachment-loading {
      top: 0;
      left: 0;
      width: 60px;
      height: 60px;
      border-radius: 9px;
      background: rgba(66, 66, 66, 0.35);
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-loading {
      top: 5px;
      left: 4.5px;
      width: 50px;
      height: 50px;
      border-radius: 8px;
      background: #e35151;
    }

    .ai-question-input__attachment-preview--pdf[uploading] .ai-question-input__attachment-pdf-badge {
      visibility: hidden;
    }

    .ai-question-input__attachment-loading-icon {
      width: 27px;
      height: 27px;
      animation: ai-attachment-loading-spin 0.65s linear infinite;
    }

    @keyframes ai-attachment-loading-spin {
      to {
        transform: rotate(360deg);
      }
    }

    .ai-question-input__attachment-preview--image {
      width: 60px;
      height: 60px;
      justify-content: center;
    }

    .ai-question-input__attachment-preview--pdf {
      width: 212px;
      height: 60px;
      background: #f4f4f4;
      border-radius: 6px;
    }

    .ai-question-input__attachment-preview--image .ai-question-input__attachment-thumb {
      width: 60px;
      height: 60px;
      border-radius: 9px;
      object-fit: cover;
      flex-shrink: 0;
      display: block;
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-pdf-badge {
      position: absolute;
      top: 5px;
      left: 4.5px;
      width: 50px;
      height: 50px;
      border-radius: 8px;
      background: #e35151;
      opacity: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      color: #ffffff;
      font-family: "Lato", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-style: normal;
      line-height: 22px;
      letter-spacing: 0;
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-pdf-info {
      position: absolute;
      top: 11px;
      left: 62.49px;
      width: 126.34px;
      height: 38px;
      opacity: 1;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: 2px;
      min-width: 0;
      box-sizing: border-box;
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-pdf-name {
      display: block;
      width: 100%;
      height: 18px;
      margin: 0;
      padding: 0;
      opacity: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      box-sizing: border-box;
      color: #424242;
      font-family: "Lato", sans-serif;
      font-size: 12px;
      font-weight: 700;
      font-style: normal;
      line-height: 18px;
      letter-spacing: 0;
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-pdf-type {
      display: block;
      width: 100%;
      height: 18px;
      margin: 0;
      padding: 0;
      text-align: left;
      font-family: "Lato", sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0;
      color: #7f7f7f;
    }

    .ai-question-input__attachment-remove {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 20px;
      height: 20px;
      opacity: 1;
      border: 0;
      padding: 0;
      margin: 0;
      background: transparent;
      cursor: pointer;
    }

    .ai-question-input__attachment-preview--image .ai-question-input__attachment-remove {
      left: 40px;
    }

    .ai-question-input__attachment-preview--pdf .ai-question-input__attachment-remove {
      left: 189px;
      width: 20px;
      height: 20px;
      top: 4px;
    }

    .ai-question-input__attachment-remove-icon {
      position: absolute;
      top: 2.5px;
      left: 2.5px;
      width: 15px;
      height: 15px;
      opacity: 1;
      display: block;
      pointer-events: none;
    }

    .ai-question-input__attachment-remove:hover .ai-question-input__attachment-remove-icon {
      opacity: 0.85;
    }

    /* Welcome state: gradient stroke + blue shadow (only before any assistant reply) */
    .ai-question-input__header--idle.ai-question-input__header--idle-welcome {
      box-shadow: 0px 1px 34.5px rgba(72, 141, 255, 0.12);
      /* stroke gradient #3570D2 → #81D1FF (border doesn't support gradient; use clip) */
      border: 3px solid transparent;
      background: linear-gradient(#ffffff, #ffffff) padding-box,
        linear-gradient(to right, #3570d2, #81d1ff) border-box;
      background-origin: border-box;
      height: 161px;
    }

    /* Landing-only horizontal offset; omit in chat (e.g. after failed submit). */
    .ai-question-input__header--idle.ai-question-input__header--idle-welcome.ai-question-input__header--idle-welcome-landing {
      transform: translateX(-32px);
    }

    .ai-question-input__header--busy {
      border: 1px solid #d9d9d9;
      box-shadow: 0px 1px 10px rgba(66, 66, 66, 0.15);
      min-height: 0;
      padding: 12px 12px 12px 24px;
    }

    .ai-question-input__busy-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      gap: 12px;
      min-height: 24px;
    }

    .ai-question-input__busy-status {
      margin: 0;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #7f7f7f;
      flex: 1;
      min-width: 0;
    }

    .ai-landing__textarea {
      width: 100%;
      border: 0;
      outline: 0;
      resize: none;
      padding: 0;
      margin: 0;
      min-height: 24px;
      max-height: 160px;
      overflow: auto;
      word-break: break-word;
      overflow-wrap: anywhere;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      background: transparent;
    }

    .ai-question-input__header--idle .ai-landing__textarea {
      flex: 1 1 0;
      min-width: 0;
      width: auto;
      box-sizing: border-box;
      align-self: stretch;
      padding-right: 8px;
    }

    .ai-question-input__header--idle--with-attachments .ai-question-input__composer-row .ai-landing__textarea {
      flex: 1 1 0;
      min-width: 0;
      width: auto;
      box-sizing: border-box;
      align-self: stretch;
      padding-right: 8px;
    }

    .ai-landing__textarea::placeholder {
      font-family: "Lato", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #7f7f7f;
      opacity: 1;
    }

    .ai-landing__actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      flex-shrink: 0;
    }

    .ai-question-input__header--idle .ai-landing__actions {
      flex-shrink: 0;
      width: auto;
      align-self: end;
      padding-left: 16px;
      margin-left: 8px;
    }

    /* Post-reply: card (gray border, card shadow) */
    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply {
      border: 1px solid #d9d9d9;
      box-shadow: 0px 1px 10px rgba(66, 66, 66, 0.15);
      min-height: 0;
      align-items: center;
      padding: 12px 12px 12px 24px;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply .ai-landing__textarea {
      align-self: center;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply .ai-landing__actions {
      align-self: center;
      margin-left: 0;
      padding-left: 12px;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle--with-attachments
      .ai-question-input__composer-row
      .ai-landing__textarea {
      align-self: center;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle--with-attachments
      .ai-question-input__composer-row
      .ai-landing__actions {
      align-self: center;
      margin-left: 0;
      padding-left: 12px;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle--with-attachments {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: 10px;
    }

    /* Post-reply multiline: welcome-like layout, gray border (no gradient) */
    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline {
      overflow: visible;
      height: auto;
      min-height: 0;
      align-items: flex-end;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline .ai-landing__textarea {
      flex: 1 1 auto;
      align-self: auto;
      overflow-y: auto;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline .ai-landing__actions {
      align-self: end;
      margin-left: 0;
      padding-left: 12px;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline.ai-question-input__header--idle--with-attachments {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline.ai-question-input__header--idle--with-attachments
      .ai-question-input__composer-row
      .ai-landing__textarea {
      flex: 1 1 auto;
      align-self: auto;
      overflow-y: auto;
    }

    .ai-question-input__header--idle.ai-question-input__header--idle-post-reply.ai-question-input__header--idle-multiline.ai-question-input__header--idle--with-attachments
      .ai-question-input__composer-row
      .ai-landing__actions {
      align-self: end;
      margin-left: 0;
      padding-left: 12px;
    }

    .ai-landing__icon-btn {
      width: 24px;
      height: 24px;
      border: 0;
      background: transparent;
      padding: 0;
      cursor: pointer;
      color: #424242;
      opacity: 0.85;
    }

    .ai-landing__send-btn {
      width: 46px;
      height: 47px;
      border-radius: 29px;
      border: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #bcbcbc;
      cursor: not-allowed;
    }

    .ai-landing__send-btn.is-active {
      background: #3570d2;
      cursor: pointer;
    }

    .ai-landing__stop-btn {
      width: 46px;
      height: 47px;
      border-radius: 29px;
      border: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #424242;
      cursor: pointer;
      padding: 0;
    }
    </style>
</template>`;
styleElement.register("prompt-input-box-style");
